module.exports = __webpack_public_path__ + "static/media/briefcase-medical.6817b906.svg";